import { render, staticRenderFns } from "./RelatedProductsMatrix.vue?vue&type=template&id=0d0a3de9&"
import script from "./RelatedProductsMatrix.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports